import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import "@/styles/index.scss"; // global css
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import "@/styles/theme/index.css"; // global css
import App from "./App";
import store from "./store";
import router from "./router";
import { getToken } from "@/utils/auth";
import "@/icons/index.js"; // icon
import "@/permission"; // permission control

import directive from "./directive"; // directive
import dayjs from "dayjs";
import HighchartsVue from 'highcharts-vue'
import visibility from "vue-visibility-change";
import * as echarts from 'echarts';
import "@/utils/v-diretive.js"; // diretive
import {message} from "@/utils/resetMessage";

Vue.prototype.$echarts = echarts 

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
Vue.prototype.basePath =
  process.env.NODE_ENV === "development" ? "/auth" : process.env.BASE_API;
// if (process.env.NODE_ENV === 'development') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(visibility);
Vue.use(ElementUI);
Vue.use(directive);
Vue.use(HighchartsVue)

// Vue.prototype.$message = message;
import { VueMasonryPlugin } from "vue-masonry"; //引入瀑布流布局
Vue.use(VueMasonryPlugin);

Vue.prototype.dayjs = dayjs;

Vue.config.productionTip = false;
Vue.prototype.storeToken = "";

visibility.change((evt, hidden) => {
  let val = getToken();
  // console.log("global callback token: " + val);
  if (!hidden) {
    if (Vue.prototype.storeToken && val && Vue.prototype.storeToken != val) {
      store.dispatch("user/setTokenNew", val).then(() => {
        Vue.prototype.storeToken = val;
        setTimeout(() => {
          router.push(`/login?accessToken=${val}&url=/`);
        }, 500);
      });
    }
  }
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
